(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* make the Noro Group credit a real link */
  var noro = document.querySelector('.fb-noro');
  if (noro && noro.tagName !== 'A'){
    var a = document.createElement('a');
    a.className = noro.className;
    a.href = 'https://norogr.com';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Noro Group — opens in a new tab');
    a.innerHTML = noro.innerHTML;
    noro.parentNode.replaceChild(a, noro);
  }

  function ready(){ requestAnimationFrame(function(){ document.body.classList.add('ready'); }); }
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready);
  setTimeout(ready, 2200);

  if (!reduce){
    document.addEventListener('click', function(ev){
      var a = ev.target.closest && ev.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch(e){ return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      ev.preventDefault();
      document.body.classList.remove('ready');
      document.body.classList.add('leaving');
      setTimeout(function(){ window.location.href = a.href; }, 460);
    });
    window.addEventListener('pageshow', function(e){ if (e.persisted){ document.body.classList.remove('leaving'); document.body.classList.add('ready'); } });
  }

  document.addEventListener('click', function(ev){
    var a = ev.target.closest && ev.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    ev.preventDefault();
    var top = t.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  });

  var bar = document.querySelector('.fb-prog'), t2 = false;
  function prog(){
    if (bar){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }
    t2 = false;
  }
  window.addEventListener('scroll', function(){ if(!t2){ t2 = true; requestAnimationFrame(prog); } }, {passive:true});
  prog();
})();
